import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Consistent breadcrumb strip used at the top of every LIFTILE product page.
 * Renders: Home › Products › {productName}
 */
export default function ProductBreadcrumb({ productName }) {
  return (
    <div className="pt-24 bg-liftile-black border-b border-white/5">
      <div className="container-x py-5 flex items-center gap-2 text-[11px] text-liftile-cream/50 font-heading uppercase tracking-[0.18em]">
        <Link to="/" className="hover:text-liftile-orange">
          Home
        </Link>
        <ChevronRight className="w-3 h-3" />
        <Link to="/products" className="hover:text-liftile-orange">
          Products
        </Link>
        <ChevronRight className="w-3 h-3" />
        <span className="text-liftile-orange truncate max-w-[360px]">
          {productName}
        </span>
      </div>
    </div>
  );
}
